// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1svDk","item":"PaymentsMobile_item__imfEC","label":"PaymentsMobile_label__2mcW0","amount":"PaymentsMobile_amount__hd0y1"};